<template>
	<div id="FeedbackPage">
		<div style="height: 75px;"></div>
		<extra></extra>
		<advertisement></advertisement>
		<div class="topArea">
			<div class="top-container">
				<div class="topMenu">
					<div class="top-logo-nav">
						<a href="" class="top-logo" title="叮咚智造泛工业互联网平台">
							<img src="../assets/logo/ddlogo-02.png" alt="">
						</a>
					</div>
					<div class="top-user">
						<div class="userInfoNav">
							<div class="index-nav-login" v-if="typeof (this.$store.state.username) == 'object'">
								<div class="avatar">
									<img src="../assets/icon/nologin.jpg" alt="">
								</div>
								<a class="uers-text" href="/login?redirect_uri=http://www.ddzzii.com/">登录/注册</a>
							</div>
							<div class="index-nav-logout" v-if="typeof (this.$store.state.username) == 'string'">
								<el-dropdown @command="handleCommand">
								  <span class="el-dropdown-link">
								    <div class="avatar">
								    	<img :src="$store.state.userIcon" alt="">
								    </div>
									<a  class="uers-text">{{ $store.state.username }}</a>
								  </span>
								  <el-dropdown-menu slot="dropdown">
								    <el-dropdown-item command="a">安全中心</el-dropdown-item>
								    <el-dropdown-item command="b">退出登录</el-dropdown-item>
								  </el-dropdown-menu>
								</el-dropdown>
							</div>
						</div>
					</div>
					<div class="top-menu-nav">
						<ul>
							<li>
								<a title="首页">首页</a>
							</li>
							<li>
								<a title="使用指南">使用指南</a>
							</li>
							<li>
								<a title="平台快讯">平台快讯</a>
							</li>
							<li class="active">
								<a class="cur" title="意见反馈">意见反馈</a>
							</li>
							<li>
								<a title="联系我们">联系我们</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div id="feedback-body">
			<div class="feedback-banner">
			</div>
			<div class="feedback-container">
				<div class="top-container">
					<div class="feedback-content">
						<p>您可以通过访问<a href="">「帮助中心」</a>查看热门问题、热门意见反馈</p>
						<div class="feedback-type">
							<span class="type-title">反馈类型：</span>
							<div class="type-list">
								<a class="t1" href="javascript:;" @click="choseType($event, '1')">使用问题</a>
								<a class="t2" href="javascript:;" @click="choseType($event, '2')">产品功能改进</a>
							</div>
						</div>
						<div class="feedback-form">
							<form action="">
								<div class="input-inline">
									<span class="chose-platform">平台选择：</span>
									<div class="chose-platform-select">
										<el-select v-model="chosePlatform" placeholder="请选择">
										    <el-option
										      v-for="item in options"
										      :key="item.value"
										      :label="item.label"
										      :value="item.value">
										    </el-option>
										  </el-select>
									</div>
								</div>
								<div class="input-inline">
									<span class="proposal-title">意见建议：</span>
									<div class="proposal-textarea">
										<el-input
										  type="textarea"
										  :autosize="{ minRows: 4, maxRows: 10}"
										  placeholder="请输入内容"
										  v-model="proposalTextarea">
										</el-input>
									</div>
								</div>
								<div class="input-inline">
									<span class="contact-title">联系方式：</span>
									<div class="contact-textarea">
										<el-input v-model="contact" placeholder="请留下联系方式（手机号、QQ、邮箱）"></el-input>
									</div>
								</div>
							</form>
						</div>
						<p class="tips">如果您的意见常见而有价值，我们将会精选至帮助中心</p>
						<div class="send-button">
							<a class="submitBtn"  href="javascript:;">发送反馈</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footer-layout></footer-layout>
	</div>
</template>

<script>
  import $ from 'jquery'
  import FooterLayout from '@/components/layout/FooterLayout'
  import Advertisement from '@/components/fixed/Advertisement'
  import Extra from '@/components/fixed/Extra'
  export default {
    name: 'Feedback',
	components: {
	  FooterLayout,
	  Extra,
	  Advertisement
	},
    data(){
      return {
		feedbackType: null,
		chosePlatform: null,
		proposalTextarea: '',
		contact: '',
		options: [{
			value: '1',
			label: '共享工人'
		},{
			value: '2',
			label: '共享仓储'
		},{
			value: '0',
			label: '其他'
		}]
      }
    },
    methods:{
		choseType (ev, type) {
			if($('.type-list .on').length > 0) {
				$('.type-list .on')[0].classList.remove('on')
			}
			ev.target.classList.add('on')
			this.feedbackType = type
		}
    },
    created(){
    },
	mounted() {
	}
  }
</script>

<style>
	.index-top {
		width: 1105px;
		margin: 0 auto;
		overflow: hidden;
	}
	#DDZZLogo {
		height: 80px;
		width: 357px;
		float: left;
	}
	#DDZZLogo a{
		margin: 10px 0;
		background-image: url(../assets/ddlogo-021.png);
		width: 357px;
		height: 60px;
		float: left;
	}
	.userInfoNav {
		float: right;
		height: 75px;
		line-height: 75px;
	}
	.userInfoNav a{
		display: inline-block;
		cursor: pointer;
		font-size: 15px;
		color: #000000;
	}
	.userInfoNav a:hover{
		text-decoration: underline;
	}
	.userInfoNav .avatar{
		position: relative;
		width: 32px;
		height: 32px;
		display: inline-block;
		margin-left: 10px;
		cursor: pointer;
	}
	.userInfoNav .avatar img{
		width: 28px;
		height: 28px;
		border-radius: 15px;
	}
	.Indexfooter{
		width: 1200px;
		margin: 30px auto 10px;
		padding-top: 20px;
		border-top: #666 solid 1px;
		color: #666;
		font-size: 14px;
		text-align: center;
	}
	.footer-first-line{
		margin-bottom: 20px;
	}
	.footer-first-line div{
		margin: 0 5px;
		display: inline-block;
	}
	.twohuateng {
		color: #666;
	}
	.topArea {
		position: fixed;
		right: 0;
		left: 0;
		top: 0;
		z-index: 1500;
		/* width: 100%; */
		height: 75px;
		line-height: 75px;
		border-bottom: 1px solid;
		border-color: #EEEEEE;
		transition: all .6s ease;
		background-color: #fff;
	}
	.topAreaMove{
		background: #000000;
	}
	.top-container{
	    width: 1105px;
	    margin: 0 auto;
	  }
	.topArea .topMenu {
		overflow: hidden;
	}
	.topArea .top-logo-nav {
		position: absolute;
		top: 0;
		height: 100%;
		font-size: 0;
		max-width: 45%;
		z-index: 3;
	}
	.top-logo img {
	    /* height: 100%; */
		height: 50px;
	    /* padding: 10px 0; */
	    max-width: 100%;
	}
	img {
	    vertical-align: middle;
	}
	.topArea .top-menu-nav {
		width: 474px;
		float: right;
		overflow: hidden;
		position: relative;
		z-index: 2;
	}
	.topArea .top-menu-nav ul{
		display: block;
		margin: 0;
		padding: 0;
		list-style: none;
		width: 3999px;
	}
	.topArea .top-menu-nav ul li{
		float: left;
		margin: 0;
		padding: 0;
		list-style: none;
		position: relative;
		white-space: nowrap;
		cursor: pointer;
	}
	.topArea .top-menu-nav ul li.active a::after,
	.topArea .top-menu-nav ul li:hover a::after {
	  width: 100%;
	}
	.topArea .top-menu-nav ul li.active a.cur {
	  color: #1492ff;
	  background: #F3F4F8;
	}
	.topArea .top-menu-nav ul li a::after {
		content: '';
		height: 3px;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 0;
		background: #1492ff;
		transition: all .6s ease;
	}
	.topAreaMove .top-menu-nav ul li a::after {
		background-color: #ff6600;
	}
	.topArea .top-menu-nav ul li a{
		display: block;
		position: relative;
		color: #000000;
	}
	.topArea .top-menu-nav ul li a{
		display: block;
		padding: 0 15px;
		font-weight: normal;
		position: relative;
		z-index: 2;
		color: #000000;
		transition: color .3s;
		-moz-transition: color .3s;
		-ms-transition: color .3s;
		-o-transition: color .3s;
		-webkit-transition: color .3s;
		font-size: 18px;
		/* font-weight: 800; */
	}
	.top-user{
		cursor: pointer;
		z-index: 1501;
		transition: all ease 0.6s;
		float: right;
	}
	.top-user a{
		color: #000000;
	}
	.index-nav-login a.uers-text{
		font-size: 18px;
		font-weight: normal;
		/* font-weight: 800; */
	}
</style>

<style>
	#FeedbackPage {
		background: #f6f6f8;
	}
	#feedback-body .feedback-banner {
		width: 100%;
		height: 360px;
		background: url(../assets/feedback-banner.jpg) no-repeat center;
		position: relative;
		overflow: hidden;
	}
	#feedback-body .feedback-container {
		
	}
	#feedback-body .feedback-content {
		background: #fff;
		padding: 60px 520px 0px 120px;
	}
	#feedback-body .feedback-content p{
		font-size: 12px;
		color: #999;
		margin-left: 30px;
	}
	#feedback-body .feedback-content p.tips{
		margin-left: 130px;
	}
	#feedback-body .feedback-content p a{
		color: #1492ff
	}
	#feedback-body .feedback-content .feedback-type,
	#feedback-body .feedback-form .chose-platform-select,
	#feedback-body .feedback-form .proposal-textarea,
	#feedback-body .feedback-form .contact-textarea{
		padding-left: 130px;
		position: relative;
		min-height: 34px;
		margin: 20px 0;
	}
	#feedback-body .feedback-type .type-title,
	#feedback-body .feedback-form .chose-platform,
	#feedback-body .feedback-form .proposal-title,
	#feedback-body .feedback-form .contact-title{
	    position: absolute;
	    left: -16px;
	    top: 0;
	    font-size: 16px;
	    font-weight: 500;
	    color: rgba(0,0,0,.65);
	    line-height: 34px;
	    width: 127px;
	    text-align: right;
	}
	#feedback-body .feedback-form .chose-platform::before,
	#feedback-body .feedback-form .proposal-title::before{
		content: '*';
		position: relative;
		left: -4px;
	    color: #E94039;
	}
	#feedback-body .feedback-type .type-list a{
		display: inline-block;
		margin-right: 5px;
		height: 34px;
		line-height: 33px;
		text-align: center;
		padding: 0 28px;
		border-radius: 4px;
		border: 1px solid rgba(223,227,233,1);
		color: #666;
		font-size: 14px;
	}
	#feedback-body .feedback-type .type-list a:hover{
		color: #1492ff;
		border-color: #89c3eb;
		font-weight: 700;
	}
	#feedback-body .feedback-type .type-list a.on{
		color: #1492ff;
		border-color: #89c3eb;
		font-weight: 700;
	}
	#feedback-body .input-inline{
		position: relative;
		margin-bottom: 26px;
	}
	#feedback-body .send-button{
		padding: 30px 130px;
	}
	#feedback-body .send-button .submitBtn{
		display: block;
		cursor: pointer;
		border-radius: 4px;
		width: 100px;
		height: 40px;
		line-height: 40px;
		margin-right: 14px;
		text-align: center;
		color: #fff;
		background-image: linear-gradient(to right,#2ca9e1,#1492ff);
		font-size: 16px;
	}
	#feedback-body .send-button .submitBtn:hover{
		opacity: .9;
		transition: 0.2s;
		box-shadow: 0 2px 8px 0 rgba(0,0,0,.15);
		background-image: linear-gradient(to right,#2caaf7 ,#14a5ff);
	}
</style>